"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Switch = ({ disabled = false, label, onClick, sx, selected = false }) => {
    const handleToggle = (event) => {
        if (!disabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
        }
    };
    const layoutStyles = {
        display: "inline-flex",
        justifyContent: "center",
        minHeight: "spacing-6"
    };
    const appearanceStyles = {
        borderRadius: "radius-round",
        borderStyle: "solid",
        borderWidth: 0,
        transition: "colorMedium",
        pointerEvents: disabled ? "none" : "auto"
    };
    const colorStyles = react_1.default.useMemo(() => ({
        backgroundColor: selected
            ? "switch-surface-selected-enabled"
            : "switch-surface-notselected-enabled",
        ":hover": {
            backgroundColor: selected
                ? "switch-surface-selected-hover"
                : "switch-surface-notselected-hover"
        },
        ":active": {
            backgroundColor: selected
                ? "switch-surface-selected-click"
                : "switch-surface-notselected-click"
        },
        ":focus-visible": {
            outlineWidth: "spacing-1",
            outlineStyle: "solid",
            outlineColor: "focus",
            outlineOffset: "2px"
        }
    }), [selected]);
    const knobContainerStyles = {
        alignItems: "center",
        justifyContent: "center",
        marginX: "spacing-1",
        minWidth: "spacing-8",
        position: "relative"
    };
    const knobStyles = {
        backgroundColor: "switch-onsurface-color",
        borderRadius: "radius-round",
        boxShadow: disabled ? "shadow-none" : "shadow-100",
        height: "spacing-5",
        left: selected ? "spacing-5" : "spacing-none",
        minWidth: "spacing-5",
        position: "absolute",
        top: "spacing-1",
        transition: "left 0.2s ease"
    };
    const disabledStyles = react_1.default.useMemo(() => {
        if (disabled) {
            return {
                backgroundColor: "switch-surface-color-disabled",
                cursor: "not-allowed",
                ":hover": {
                    backgroundColor: "switch-surface-color-disabled"
                },
                ":active": {
                    backgroundColor: "switch-surface-color-disabled"
                }
            };
        }
        return {};
    }, [disabled]);
    const containerStyles = {
        alignItems: "center",
        color: disabled ? "text-input-disabled" : "text-default",
        display: "inline-flex",
        fontSize: "font-size-4",
        gap: "spacing-3",
        marginLeft: "spacing-2",
        cursor: disabled ? "not-allowed" : "pointer"
    };
    return (react_1.default.createElement(foundations_1.Box, { role: "group", sx: Object.assign(Object.assign({}, containerStyles), sx), onClick: handleToggle },
        react_1.default.createElement(foundations_1.Box, { as: "button", role: "switch", "aria-checked": selected, "aria-disabled": disabled, "aria-labelledby": label ? `${label.replace(/\s+/g, "-")}-label` : "switch-label", disabled: disabled, sx: Object.assign(Object.assign(Object.assign(Object.assign({}, layoutStyles), appearanceStyles), colorStyles), disabledStyles) },
            react_1.default.createElement(foundations_1.Box, { sx: knobContainerStyles },
                react_1.default.createElement(foundations_1.Box, { sx: knobStyles }))),
        label && (react_1.default.createElement(foundations_1.Box, { as: "span", id: `${label.replace(/\s+/g, "-")}-label`, sx: { cursor: disabled ? "not-allowed" : "pointer" } }, label))));
};
exports.Switch = Switch;
//# sourceMappingURL=Switch.js.map